import React from 'react';
import {Button} from '@mui/material';
import {styled} from '@mui/material/styles';
import {ButtonMuiProps} from './ButtonMuiProps';
import LEGACY_COLORS from '@/styles/legacyColors';

function ButtonMui(props: ButtonMuiProps) {
  const {testID, type, link, onClick, children, ...rest} = props;

  const LinkStyleButton = styled(Button)({
    'backgroundColor': 'transparent',
    'color': LEGACY_COLORS.GRAY,
    'textDecoration': 'underline',
    'borderRadius': '3px',
    'textTransform': 'capitalize',
    'fontWeight': '300',
    'padding': '9px 0px 7px 0px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  });

  const FilledStyledButton = styled(Button)({
    'backgroundColor': LEGACY_COLORS.GRAY,
    'color': '#fff',
    'borderRadius': '3px',
    'textTransform': 'capitalize',
    'fontWeight': '300',
    'padding': '9px 24px 7px 24px',
    '&:hover': {
      backgroundColor: LEGACY_COLORS.GRAY,
    },
  });

  if (type === 'filled') {
    return (
      <FilledStyledButton {...rest} onClick={onClick} href={link}>
        {children}
      </FilledStyledButton>
    );
  }

  return (
    <LinkStyleButton {...rest} onClick={onClick} href={link}>
      {children}
    </LinkStyleButton>
  );
}

export default ButtonMui;
